import { render, staticRenderFns } from "./ListJob.vue?vue&type=template&id=2874137a&scoped=true&"
import script from "./ListJob.vue?vue&type=script&lang=js&"
export * from "./ListJob.vue?vue&type=script&lang=js&"
import style0 from "./ListJob.vue?vue&type=style&index=0&id=2874137a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874137a",
  null
  
)

export default component.exports